import { booleanAttribute, Directive, input } from '@angular/core';
import { V3ScrollableContentListController } from './scrollable-content-list.controller';

/**
 * Extends the scrollable content list to add standard configuration inputs for button based grids/ribbons.
 */
@Directive()
export class V3ContentButtonListController extends V3ScrollableContentListController {
  public readonly eventSource = input.required<string>();
  public largeOnMobile = input(false, { transform: booleanAttribute });
  public nameOnBottom = input(false, { transform: booleanAttribute });
  public showTagLine = input(false, { transform: booleanAttribute });

  override buildWrapperKlasses() {
    const gridKlasses = super.buildWrapperKlasses();

    if (this.largeOnMobile()) {
      gridKlasses.push('large-on-mobile');
    }
    return gridKlasses;
  }
}
